package tools

import com.ionspin.kotlin.bignum.decimal.BigDecimal

val Int.bd: BigDecimal get() = BigDecimal.fromInt(this)
val Long.bd: BigDecimal get() = BigDecimal.fromLong(this)
val Double.bd: BigDecimal get() = BigDecimal.fromDouble(this)
val String.bd: BigDecimal get() = BigDecimal.parseString(this)